export default __webpack_public_path__ + "static/media/welcome.134d607e.png";